import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, Grid } from "@mui/material";
import GeralTable from "./RelatoriosTabela";
import APIAxios from "../../Api/APIAxios";
import { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { GetAPI } from "../Backend/GetAPI";
import PageTitle from "../Layout/PageTitle";

const URL_SERVICE = "/relat/listar";

const RelatoriosListar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();

  const [cmpSelecao, setCmpSelecao] = useState(10);
  const [relatorios, setRelatorios] = useState([]);
  const [valorSelecionado, setValorSelecionado] = useState(""); // NOVO

  const handleListar = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    const response = await GetAPI(apiAxios, URL_SERVICE);
    setLoading(false);

    if (!response.success) {
      setRelatorios([]);
      setAvisoErro(response.errorMessage);
    } else {
      setRelatorios(response.data);
    }

  };

  useEffect(() => {
    handleListar();
  }, []);

  //Função para seleção de filtro
  const getAutocompleteOptions = () => {
    let options = [];

    switch (cmpSelecao) {
      case 10:
        options = relatorios.map((reg) => reg.id);
        break;
      case 20:
        options = relatorios.map((reg) => reg.descricao);
        break;
      default:
        return [];
    }

    // Ordena de forma alfabética ou numérica
    return options.sort((a, b) => {
      if (typeof a === 'string') return a.localeCompare(b);
      return a - b;
    });
  };

  // NOVO: Filtra conforme o valor selecionado
  const RelatoriosFiltrados = valorSelecionado
    ? relatorios.filter((reg) => {
      switch (cmpSelecao) {
        case 10:
          return String(reg.id) === String(valorSelecionado);
        case 20:
          return reg.descricao === valorSelecionado;
        default:
          return true;
      }
    })
    : relatorios;

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Relatórios"
        subtitle="Listagem de Relatórios"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}

      <Box sx={{ color: "red", marginBottom: 2 }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          {/* Filtro */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Filtrar por:</InputLabel>
              <Select
                labelId="cmpSelecao"
                id="cmpSelecao"
                label="Filtrar por"
                value={cmpSelecao}
                onChange={(e) => setCmpSelecao(e.target.value)}
              >
                <MenuItem value={10}>Código</MenuItem>
                <MenuItem value={20}>Descrição</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Campo de busca */}
          <Grid item xs={12} md={3}>
            <Autocomplete
              id="cmpDescricao"
              freeSolo
              options={getAutocompleteOptions()}
              value={valorSelecionado}
              onInputChange={(event, newValue) => setValorSelecionado(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Localizar" fullWidth />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
          </Grid>
        </Grid>
        <GeralTable
          relatorios={RelatoriosFiltrados}
          setLoading={setLoading}
          setRelatorios={setRelatorios}
          setAvisoErro={setAvisoErro}
          setAvisoSucesso={setAvisoSucesso}
        />
      </Box>
    </Box>
  );
};

export default RelatoriosListar;
